/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Serializer for skill details including area and subarea information.
 */
export interface TimeLineSkillDetail { 
    name: string;
    areaName: string;
    areaId: string;
    areaColor: string;
    subareaName: string;
    subareaId: string;
    subareaColor: string;
}